// The navbar's text links beside its icons, Tencent Cloud's and Aliyun's
// 费用 and 工单 — the part of the navbar that differs between the consoles
// (App.vue is the same file in both; the account is NavAccount).
import type { Component } from 'vue'
import NavTickets from '@/components/navbar/NavTickets.vue'

export interface NavLink {
  route: string
  /** An i18n key. */
  label: string
  /** A link with a panel under it draws itself (NavMenu: its cell and the panel). */
  panel?: Component
}

export const NAV_LINKS: NavLink[] = [
  { route: 'tasks', label: 'navbar.tasks' },
  { route: 'tickets', label: 'navbar.tickets', panel: NavTickets },
  { route: 'audit', label: 'navbar.audit' },
]

// What floats over this console's pages: nothing (the AI 助手 is the
// customer console's).
export const OVERLAYS: Component[] = []

// What stands in the navbar right of the search box: nothing here.
export const NAV_EXTRAS: Component[] = []
